module.exports = __webpack_public_path__ + "static/media/icon-timer.2ddaf2ba.svg";